import styled from '@emotion/styled';

export const HistoryContainer = styled.div`
  margin-top: 1.5rem;
  padding: 1.5rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fafafa;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

export const ComparisonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const VersionColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; /* Allows flex children to shrink below content size */
  overflow: hidden; /* Prevents overflow */
`;

export const VersionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
`;

export const VersionLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  overflow: hidden;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
  min-width: 0;
  overflow: hidden;
`;

export const FieldLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 4px;
`;

export const FieldContent = styled.div`
  padding: 0.75rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  min-height: 60px;
  font-size: 14px;
  line-height: 1.5715;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow-x: auto;
  max-width: 100%;
  white-space: pre-wrap;
`;

export const EmptyState = styled.div`
  padding: 2rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
`;

